import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexLearning',
  setup(__props) {

const LearningList = defineAsyncComponent(() => import("@/components/theme/learning/list/LearningList.vue"))
const LearningFilter = defineAsyncComponent(() => import("@/components/common/LearningFilter.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Learning",
      mains: "Learning List",
      title: "Learning List"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(LearningList)),
        _createVNode(_unref(LearningFilter))
      ])
    ])
  ], 64))
}
}

})